<template>
  <div
    class="main-nav-holder"
    @mouseenter="handleMouseEnter"
    @mouseleave="handleMouseLeave"
  >
    <div
      class="nav-block"
      :class="RMTEditMode ? 'nav-block-visible' : ''"
    ></div>
    <div class="nav-button-holder">
      <NavButton
        :type="'nelson'"
        :option="{ name: 'nelson' }"
        @mouseup="handleNelson"
      />
      <NavButton
        v-for="(menu, index) in menuStore.getMenu"
        :key="index"
        :option="menu"
        @mouseup="showMenu(menu)"
      />
      <UserBadge />
    </div>
    <div ref="subMenuHolder" class="nav-sub-menu-holder">
      <div ref="marketingMenu" class="nav-sub-menu">
        <SubMenuButton
          :option="{ name: '' }"
          :is-title="true"
          :is-spacer="true"
        />
        <SubMenuButton :option="{ name: 'Marketing' }" :is-title="true" />
        <SubMenuButton
          :option="{ name: 'Library', url: '/marketing/library' }"
          :type="'no-icon'"
          :content="'internal'"
        />
      </div>
      <div ref="resourcesMenu" class="nav-sub-menu">
        <SubMenuButton
          :option="{ name: '' }"
          :is-title="true"
          :is-spacer="true"
        />
        <SubMenuButton :option="{ name: 'Price Lists' }" :is-title="true" />
        <SubMenuButton
          v-for="(menu, index) in menuStore.getLists"
          :key="index"
          :option="menu"
          :type="'app'"
          :content="'app'"
        />
      </div>
      <div ref="communityMenu" class="nav-sub-menu">
        <SubMenuButton
          :option="{ name: '' }"
          :is-title="true"
          :is-spacer="true"
        />
        <SubMenuButton :option="{ name: 'Community' }" :is-title="true" />
        <SubMenuButton
          v-for="(menu, index) in feedStore.getFeedOptions"
          :key="index"
          :option="menu"
          :type="'sub-sub'"
          :content="'filter-option'"
        />
        <SubMenuButton :option="{ name: 'FAQ' }" :type="'no-icon'" />
      </div>
      <div ref="toolsMenu" class="nav-sub-menu">
        <SubMenuButton
          :option="{ name: '' }"
          :is-title="true"
          :is-spacer="true"
        />
        <SubMenuButton :option="{ name: 'Tools' }" :is-title="true" />
        <SubMenuButton
          v-for="(menu, index) in GetTools"
          :key="index"
          :option="menu"
          :type="'app'"
          :content="'app'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import NavButton from '@/components/nav/main/NavButton';
import SubMenuButton from '@/components/nav/main/SubMenuButton';
import { useMenuStore } from '@/store/MenuStore';
import { useFeedStore } from '@/store/FeedStore';
import { useIdentityStore } from '@/store/IdentityStore';
import { mapStores, storeToRefs } from 'pinia/dist/pinia';
import { gsap } from 'gsap';
import UserBadge from '@/components/nav/UserBadge';
import { useRMTStore } from '@/store/RMTStore';

export default {
  name: 'MainNav',
  components: { UserBadge, SubMenuButton, NavButton },
  setup () {
    const RMTStore = useRMTStore();
    const { RMTEditMode } = storeToRefs(RMTStore);
    return {
      RMTStore,
      RMTEditMode,
    };
  },
  mounted () {
    this.hideAllMenus();
  },
  computed: {
    ...mapStores(useMenuStore, useFeedStore),
    GetTools () {
      let tools = useMenuStore().getTools;
      // check for access to dealer editor
      let permission = useIdentityStore().findSubscription(
        'PORTAL_EDIT_DEALERS'
      );
      var existsAlready = tools.find((s) => {
        if (s.url === '/dealer_editor') {
          return s;
        }
      });
      if (permission && !existsAlready) {
        var dealerEditor = {
          name: 'Dealer Editor',
          url: '/dealer_editor',
          img: 'nelson_logo',
        };
        tools.push(dealerEditor);
      }
      return tools;
    },
  },
  methods: {
    handleNelson () {
      this.hideSubmenu();
    },
    hideAllMenus () {
      gsap.set(
        [
          this.$refs.communityMenu,
          this.$refs.marketingMenu,
          this.$refs.toolsMenu,
          this.$refs.resourcesMenu,
        ],
        {
          display: 'none',
        }
      );
    },
    showMenu (menu) {
      this.hideAllMenus();
      if (menu.name === 'rmt') {
        return;
      }
      this.showSubmenu();
      let l = this.$refs[menu.name + 'Menu'];
      gsap.set(l, {
        display: 'inline',
      });
      for (let a = 1; a < l.children.length; a++) {
        gsap.fromTo(
          l.children[a],
          {
            x: -20,
            alpha: 0,
          },
          {
            x: 0,
            alpha: 1,
            duration: 0.5,
            ease: 'power3.inOut',
            delay: a * 0.03,
          }
        );
      }
    },
    showSubmenu () {
      this.menuStore.setSubMenuOpen(true);
      gsap.to(this.$refs.subMenuHolder, {
        width: 250 + 'px',
        duration: 0.3,
        ease: 'power3.inOut',
      });
    },
    hideSubmenu () {
      this.menuStore.setSubMenuOpen(false);
      gsap.to(this.$refs.subMenuHolder, {
        width: 0 + 'px',
        duration: 0.3,
        ease: 'power3.inOut',
      });
    },
    handleMouseEnter () {
      gsap.killTweensOf(this.hideSubmenu);
    },
    handleMouseLeave () {
      gsap.delayedCall(0.35, this.hideSubmenu);
    },
  },
};
</script>

<style>
:root {
  --nelson-green: #00bd5e;
  --nelson-blue: #0080c5;
  --nelson-green50: rgba(0, 189, 94, 0.3);
  --nelson-green10: rgba(0, 189, 94, 0.07);
}

.nav-block {
  position: absolute;
  width: 65px;
  height: 100%;
  background-color: rgba(238, 238, 238, 0.85);
  pointer-events: none;
  opacity: 0;
  transition: 0.2s opacity;
  z-index: 100000;
}

.nav-block-visible {
  opacity: 1;
  pointer-events: all;
}
</style>

<style scoped>
.nelson-logo {
  /*
  height: 50px;
  */
  aspect-ratio: 1 / 1;
  width: 65px;
  background-color: #ffffff;
}

.main-nav-holder {
  position: sticky;
  top: 0;
  height: 100vh;
  display: flex;
  z-index: 1000;
}

.nav-sub-menu-holder {
  width: 0px;
  overflow-x: hidden;
  display: flex;
}

.nav-sub-menu {
  /*overflow-x: hidden;*/
  display: none;
  width: 250px;
  min-width: 250px;
  background-color: var(--nelson-green10);
  border-right: 1px solid var(--nelson-green50);
}

.nav-button-holder {
  z-index: 99999;
}
</style>
